export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.controller.js